import { equals, omit, pipe, prop, allPass, pathEq } from "ramda";

const Author = (x) => ({
  ...omit(["content"], x),
  ...x.content,
});

const Article = (story, rels, ads) => {
  const category = rels.find(
    allPass([
      pathEq('category', ['content', 'component']),
      pathEq(story.content.category, ['content', 'category'])
    ])
  )
  const article_type = rels.find(
    allPass([
      pathEq('articletype', ['content', 'component']),
      pathEq(story.content.article_type, ['content', 'article_type'])
    ])
  )

  return {
    ...story,
    content: {
      ...story.content,
      category,
      article_type,
      authors: story.content.authors.map((id) => {
        const author = rels.find(pipe(prop("uuid"), equals(id)));

        return Author(author);
      }),
      ads: {
        article_banner_panel: ads?.article_banner_panel?.content
      }
    },
  }
};

const Articles = (data) => ({
  total: data.total,
  articles: data.stories.map((story) => Article(story, data.rels, data.adv)),
});

export { Articles, Article };
